import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form } from '@talend/design-system';

import { I18N_NAME_SPACE } from '../../../../../constants';
import { CADFormModel } from '../../../CAD.types';
import { Mandatory } from '../Mandatory';

export interface TextProps {
	rhf: UseFormReturn<CADFormModel>;
	id: string;
	readOnly: boolean;
}

export function Text({ id, rhf, readOnly }: TextProps) {
	const { t } = useTranslation(I18N_NAME_SPACE);
	const mandatory = rhf.watch('mandatory');

	useEffect(() => {
		if (rhf.formState.isSubmitted) {
			rhf.trigger('defaults');
		}
	}, [mandatory]);

	return (
		<>
			<Mandatory rhf={rhf} readOnly={readOnly} />
			<Form.Text
				{...rhf.register('defaults', {
					required:
						mandatory &&
						t('CUSTOM_ATTRIBUTE_FORM_TEXT_DEFAULT_REQUIRED', 'Default value is required'),
					validate: {
						required: value => !(rhf.getValues().mandatory && !value),
					},
					pattern: /^(?!\s+$).+/,
				})}
				id={`${id}-defaults`}
				data-testid={`${id}-defaults`}
				required={mandatory}
				readOnly={readOnly}
				hasError={!!rhf.formState.errors.defaults}
				description={rhf.formState.errors.defaults ? rhf.formState.errors.defaults.message : ''}
				label={t('CUSTOM_ATTRIBUTE_FORM_TEXT_DEFAULT_LABEL', 'Default value')}
				placeholder={t('CUSTOM_ATTRIBUTE_FORM_TEXT_DEFAULT_PLACEHOLDER', 'Enter the default value')}
			/>
		</>
	);
}

Text.displayName = 'Text';
